<template>
    <v-touch
        @swiperight="swiperright"
        class="wrapper"
    >
        <div class="commonFormStyles customerEntry">
            <van-nav-bar
                :title="title"
                left-text="客户查询"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div
                            slot="title"
                            class="title"
                        >
                            <i class="iconfont icondingdan"></i>基础信息
                        </div>
                        <van-cell
                            :value="customerData.no"
                            title="客户编号"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.name"
                            title="客户名称"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.nature_name"
                            title="客户性质"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_33.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.license_code"
                            title="统一社会信用代码"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_33.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.level_name"
                            title="客户等级"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_40.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.address"
                            title="客户地址"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_40.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.rel_client_name"
                            title="关联企业"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_33.png')"
                        ></van-cell>
                        <van-cell
                            v-if="customerData.is_parent"
                            value="是"
                            title="是否是上级单位"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            v-if="!customerData.is_parent"
                            value="否"
                            title="是否是上级单位"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.creator"
                            title="登记人"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.created"
                            title="登记时间"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="customerData.remarks"
                            title="备注"
                            class="customerNub"
                            :icon="require('@/assets/images/icons/icon_gy_4.png')"
                        ></van-cell>
                    </van-collapse-item>
                </van-collapse>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 录入客户
    name: 'customer-entry',
    components: {},
    props: {},
    data() {
        return {
            title: '',
            activeNames: ['1'],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 录入客户数据赋值
        this.customerData = this.$route.query.data;
        this.title = this.customerData.type_name;
    },
    mounted() { },
    destroyed() { },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/customerManagement_leader' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/customerManagement_leader' });
        },
    },
};
</script>
<style lang="stylus">
.customerEntry
    height 100%
    section
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        .van-icon
            .van-icon__image
                width 16rpx
                height 16rpx
                margin-top 3rpx
                margin-right 5rpx
        .van-collapse
            &:after
                display none
        .van-cell__title
            font-size 14rpx
            line-height 24rpx
            color #061F3E
            .iconfont
                font-size 18rpx
                margin-right 5rpx
        .van-collapse-item__content
            .van-cell__title
                font-size 16rpx
        .title
            font-size 17rpx
            color #3495FB
        .van-collapse-item__content
            padding 0
        .van-field__control, .van-cell__value
            color #979EA7
            &::placeholder
                color #D7D7D7 !important
        .textarea
            position relative
            &:before
                position absolute
                top 20rpx
                left 26rpx
            textarea
                text-indent 30rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 10rpx
                    height 130rpx !important
        .contactInfo
            h5,p
                font-size 16rpx
                line-height 45rpx
                text-align center
            h5
                color #333333
                background #F8F8F8
            p
                color #0189FC
                border-bottom 1px solid  #F0F0F0
</style>